import { createContext } from 'react';
import { Issue } from '../../constants';
export const HomeContext = createContext<HomeContextProps>({
    mode: 'top-stories',
    setMode: () => { },
    selectedIssue: null,
    setSelectedIssue: () => { },
    setAuthIsOpen: () => { },
    setShowInstallation: () => { },
    onClickLogOut: () => { },
    setShowLogout: () => { },
    isAuthenticated: false
});

interface HomeContextProps {
    mode: ModeType;
    setMode: (mode: ModeType) => void;
    isAuthenticated: boolean;
    selectedIssue: Issue | null;
    setSelectedIssue: (issue: Issue | null) => void;
    setAuthIsOpen: (isAuthOpen: boolean) => void;
    setShowInstallation: (value: boolean) => void;
    setShowLogout: (value: boolean) => void;
    onClickLogOut: () => void;
}

export type ModeType = 'top-stories' | 'magazines' | 'library' | 'contest' | 'daily-news';